import React from 'react';

import Icon from "./icons";

function Nav(props) {
  return (
    <header>
      <nav className="navbar navbar-expand navbar-dark bg-gray-800 fixed-top">
        <a className="navbar-brand d-flex align-items-center" href="/">
          {Icon.logo} <span className="ml-3">Bundles</span>
        </a>
        <button
          className="btn btn-secondary my-2 my-sm-0 ml-auto"
          type="button"
          data-toggle="modal"
          data-target="#whatAreOblacBundlesModal"
        >
          What are OBLAC Bundles?
        </button>
      </nav>
    </header>
  );
}

export default Nav;
